// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input#seat-text:focus::placeholder{color:#414040}input#seat-text::placeholder{color:transparent}
`, "",{"version":3,"sources":["webpack://./checkout/ask-info2.vue"],"names":[],"mappings":"AACA,mCACC,aAAA,CAED,6BACC,iBAAA","sourcesContent":["\ninput#seat-text:focus::placeholder {\n\tcolor: rgb(65, 64, 64);\n}\ninput#seat-text::placeholder {\n\tcolor: transparent;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
